/**
 * Слияние истории раскладов между устройством и сервером.
 *
 * Вынесено в общий код по двум причинам. Во-первых, предел хранения должен
 * быть один: пока клиент держал 100 записей, сервер хранил 200 и отдавал 50,
 * устройство после каждой синхронизации теряло половину своей истории.
 * Во-вторых, само слияние стоит проверять тестами, а не глазами.
 */

/**
 * Сколько раскладов хранится и отдаётся. Одно число и на устройстве, и на
 * сервере: любое расхождение означает, что чья-то часть истории недостижима.
 */
export const HISTORY_LIMIT = 100

export interface HistoryEntry {
  id: string
  ts: number
}

/**
 * Объединяет две истории по идентификатору, новые записи первыми.
 *
 * Расклады неизменяемы, поэтому объединение безопасно с любого числа
 * устройств. Заменять локальную историю ответом сервера нельзя: ответ мог
 * уйти до того, как пользователь сделал последний расклад, и тот бы пропал.
 *
 * При совпадении идентификаторов берётся запись с сервера — она прошла
 * слияние и содержит толкование, дописанное с другого устройства.
 */
export function mergeHistory<T extends HistoryEntry>(local: T[], server: T[], limit = HISTORY_LIMIT): T[] {
  const byId = new Map<string, T>()
  for (const entry of local) byId.set(entry.id, entry)
  for (const entry of server) byId.set(entry.id, entry)

  return [...byId.values()].sort((a, b) => b.ts - a.ts).slice(0, limit)
}
